












import Vue from 'vue'

export default Vue.extend({
  name: 'LinkedItemDrawerDropdown',

  props: {
    label: {
      type: String,
      default: 'Unlink',
    },
  },
})
